import * as actions from '../actionTypes/partPaymentActionType';

export const setPartPaymentLoader = (_data: any) => {
    return {
        type: actions.SET_PART_PAYMENT_LOADER,
        payload: _data
    }
}

export const getPartPaymentList = (_data: any, _callback: any) => {
    return {
        type: actions.GET_PART_PAYMENT_LIST,
        payload: _data,
        callback: _callback
    }
}

export const setPartPaymentList = (_data: any) => {
    return {
        type: actions.SET_PART_PAYMENT_LIST,
        payload: _data
    }
}

export const uploadPartPaymentFile = (_data: any, _callback: any) => {
    return {
        type: actions.UPLOAD_PART_PAYMENT_FILE,
        payload: _data,
        callback: _callback
    }
}
